import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  return (
    <footer className="bg-tesla-black border-t border-white/5">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="max-w-sm"
            >
              <div className="text-2xl font-bold text-white mb-4">
                CSFADE Partner
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                Партнерская программа для заработка на CS2 кейсах
              </p>
            </motion.div>
          </div>

          {/* Navigation */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="md:justify-self-end"
          >
            <h3 className="text-white font-semibold text-base mb-4">Навигация</h3>
            <nav className="space-y-2">
              {[
                { href: "#features", label: "Функции" },
                { href: "#statistics", label: "Цифры" },
                { href: "#how-it-works", label: "Как работает" },
                { href: "/dashboard", label: "Панель" }
              ].map((link, index) => (
                <motion.div key={link.href}>
                  <a 
                    href={link.href} 
                    className="block text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </a>
                </motion.div>
              ))}
            </nav>
          </motion.div>
        </div>

        {/* Bottom section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="border-t border-white/5 mt-8 pt-6"
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-xs">
              © 2024 CSFade Partner
            </div>
            
            <div className="text-gray-400 text-xs">
              Создано для CS2 игроков
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 